<template>
  <v-app>
    <HeaderComponent class="panel" />
    <AboutMeComponent class="panel" />
    <ExperienceComponent class="panel" />
    <ProjectsComponent class="panel" id="projects"/>
    <ContactMeComponent class="panel" id="contact"/>
    <FooterComponent class="panel"/>
  </v-app>
</template>

<script setup>
// import { onMounted } from 'vue';
import HeaderComponent from './components/HeaderComponent.vue';
import AboutMeComponent from './components/AboutMeComponent.vue';
import ProjectsComponent from './components/ProjectsComponent.vue';
import ExperienceComponent from './components/ExperienceComponent.vue';
import ContactMeComponent from './components/ContactMeComponent.vue';
import FooterComponent from './components/FooterComponent.vue';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

</script>

<style>

</style>
